"use client";
import SectionTitle from "@/shared/app/ui/text/PageSectionTitle";
import { motion } from "framer-motion";
import Image from "next/image";

export default function MovementMobilitySection() {
  return (
    <div className="w-full xl:max-w-[1280px] mx-auto px-5 xl:px-2  py-30 md:py-60">
      <SectionTitle
        label="Mobility Data"
        title="다양한 형태의 이동정보 데이터"
        description={
          <>
            이동정보 데이터는 다양한 형태로 가공되어
            <br />
            사용자들에게 정보를 제공합니다.
          </>
        }
      />

      {/* 이미지 */}
      {/* PC 버전 */}
      <motion.div
        className="relative w-full aspect-[1440/1400] overflow-hidden mt-30 hidden lg:flex justify-center items-center"
        initial={{ opacity: 0, y: 50, scale: 0.95 }}
        whileInView={{ opacity: 1, y: 0, scale: 1 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        viewport={{ once: true, amount: 0.3 }}
      >
        <Image
          src="/assets/images/page/service/movement/mobility.png"
          alt="device"
          fill
          className="object-contain"
        />
      </motion.div>

      {/*  모바일 버전 */}
      <motion.div
        className="relative w-full aspect-[362/1558] overflow-hidden mt-20 flex lg:hidden justify-center items-center"
        initial={{ opacity: 0, y: 50, scale: 0.95 }}
        whileInView={{ opacity: 1, y: 0, scale: 1 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        viewport={{ once: true, amount: 0.1 }}
      >
        <Image
          src="/assets/images/page/service/movement/mobility_m.png"
          alt="device"
          fill
          className="object-contain"
        />
      </motion.div>
    </div>
  );
}
